import { Component } from "@angular/core";
import { ModalController } from "ionic-angular";
import { NavController, NavParams } from "ionic-angular";
import { Committee } from "../../models/interfaces/committee.model";
import { CommitteeMember } from "../../models/interfaces/committee.model";
import { Member } from "../../models/interfaces/member.model";
import { CommitteeAddPage } from "../../pages/committee/committee_add";
import { CommitteeUpdatePage } from "../../pages/committee/committee_update";
import { CommitteeMemberAddPage } from "../../pages/committee/committeemember_add";
import { CommitteeMemberUpdatePage } from "../../pages/committee/committeemember_update";
import { MemberViewPage } from "../../pages/member/member_view";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-committee",
  templateUrl: "committee.html",
})

export class CommitteePage {
  public static readonly CMBR_ADD_ACCESS = "addCommitteemember";
  public static readonly CMBR_UPD_ACCESS = "updateCommitteemember";
  public static readonly COM_ADD_ACCESS = "addCommittee";
  private currentUser: Member;

  private hasAddPledgeAccess: boolean = false;
  private hasAddCMbrAccess: boolean = false;
  private hasUpdCMbrAccess: boolean = false;
  private hasAddCommitteeAccess: boolean = false;
  private committeeMember$: any;
  private tmpSearchObject;
  private cpComment;
  private pastCommittees;
  private pastCommittee = [];
  private pastDistinctCommittees;
  private committee: any;
  private committeemember: CommitteeMember;
  private styleName: string ="";
  private showCurrent: boolean = true;
  private zippedCurrent: boolean = false;
  private showPast: boolean = false;
  private zippedPast: boolean = true;
  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    private db: DbserviceProvider, public modalCtrl: ModalController) {
    console.log("CommitteePage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    if (this.authService.currentUser) {
      this.authService.currentUser.subscribe(
        (user) => {
          this.currentUser = user;
          this.hasAddCMbrAccess = this.db.hasAccess(CommitteePage.CMBR_ADD_ACCESS);
          this.hasUpdCMbrAccess = this.db.hasAccess(CommitteePage.CMBR_UPD_ACCESS);
          this.hasAddCommitteeAccess = this.db.hasAccess(CommitteePage.COM_ADD_ACCESS);
        },
      );
    }
  }

  private ionViewWillEnter() {
    console.log("CommitteePage ionViewWillEnter");
    this.onInitPage();
  }

  private unique(arr, keyProps) {
    const kvArray = arr.map(entry => {
      const key = keyProps.map(k => entry[k]).join('|');
      return [key, entry];
    });
    const map = new Map(kvArray);
    return Array.from(map.values());
  }

  private onInitPage() {
    console.log("CommitteePage onInitPage");

    if (this.hasAddCommitteeAccess) {
      this.db.dbCol({
        "action": "select", "mapObject": "committee_member_role",
        "sqlExtended": " where role.ro_group in ('Committee','Admin')  order by committee.co_todate desc, role.ro_order asc",
      }).subscribe((cmt) => {
        this.pastCommittees = cmt;
        this.pastDistinctCommittees = this.unique(cmt, ['co_id']);

        this.pastDistinctCommittees.forEach((el) => {
          if (this.pastCommittee[el.co_id] === undefined || this.pastCommittee[el.co_id] == null) {
            this.pastCommittee[el.co_id] = [];
          }
          this.pastCommittee[el.co_id] = cmt.filter(t => t.co_id === el.co_id)
        })
      })
    } else {

      this.db.dbCol({
        "action": "select", "mapObject": "committee_member_role",
        "sqlExtended": " where role.ro_group='Committee'  order by committee.co_todate desc, role.ro_order asc",
      }).subscribe((cmt) => {
        this.pastCommittees = cmt;
        this.pastDistinctCommittees = this.unique(cmt, ['co_id']);

        this.pastDistinctCommittees.forEach((el) => {
          if (this.pastCommittee[el.co_id] === undefined || this.pastCommittee[el.co_id] == null) {
            this.pastCommittee[el.co_id] = [];
          }
          this.pastCommittee[el.co_id] = cmt.filter(t => t.co_id === el.co_id)
        })
      })

    }

    this.db.dbCol({
      "action": "select", "mapObject": "committee",
      "sqlExtended": " where committee.co_active_flg=1"
    }).subscribe((data) => {
      
      this.cpComment=data[0].cp_comment;
      this.committee = data[0];
    });

    if (this.hasAddCommitteeAccess) {
      this.tmpSearchObject = this.committeeMember$ = this.db.dbCol({
        "action": "select", "mapObject": "committee_member_role",
        "sqlExtended": " where role.ro_group IN ('Admin','Committee') and committee.co_active_flg=1 order by role.ro_order",
      });
    } else {
      this.tmpSearchObject = this.committeeMember$ = this.db.dbCol({
        "action": "select", "mapObject": "committee_member_role",
        "sqlExtended": " where role.ro_group='Committee' and committee.co_active_flg=1 order by role.ro_order",
      });
    }
    
  }


  private updateCommitteeMember(committeemember: CommitteeMember) {
    console.log("CommitteePage updateCommitteeMember");
    console.log("CommitteePage authService.isLoggedIn", this.authService.isLoggedIn);

    if (this.authService.isLoggedIn) {
      // For Admin allow to update CommitteeMember
      if (this.hasAddCommitteeAccess) {
        if (this.hasUpdCMbrAccess) {
          this.navCtrl.push(CommitteeMemberUpdatePage, {
            "committeemember": committeemember,
          });
        }
        // All other members show details of the member
      } else {
        this.navCtrl.push(MemberViewPage, {
          "member": committeemember,
        });
      }
    }
  }

  private addCommitteeMember(committee: Committee) {
    console.log("CommitteePage addCommitteeMember");
    this.navCtrl.push(CommitteeMemberAddPage, { "committee": committee });
  }


  private updateCommittee(committee: Committee) {
    console.log("CommitteePage updateCommittee");
    this.navCtrl.push(CommitteeUpdatePage, {
      "committee": committee,
    });
  }

  private addCommittee() {
    console.log("CommitteePage addCommittee");
    this.navCtrl.push(CommitteeAddPage, {
      "committee": this.committee,
    });
  }

  private toggleCurrent() {
    console.log("CommitteePage togglePast");
    if (this.showCurrent === true) { this.showCurrent = false; } else { this.showCurrent = true; }
    this.zippedCurrent = !this.zippedCurrent;
  }

  private togglePast() {
    console.log("CommitteePage togglePast");
    if (this.showPast === true) { this.showPast = false; } else { this.showPast = true; }
    this.zippedPast = !this.zippedPast;
  }

}



// WEBPACK FOOTER //
// ./src/pages/committee/committee.ts